module.exports = __webpack_public_path__ + "img/1522202312.d6f8844b.jpg";